import clsx from 'clsx';
import { ReactNode } from 'react';

export type SortColumn = {
  column?: 'token' | 'price' | 'volume' | 'change' | 'liquidity';
  order?: 'asc' | 'desc';
};

export type TableSorterProps = {
  onClick?: () => void;
  column: string;
  currentSort?: SortColumn;
  children?: ReactNode;
};

export function TableSorter({ onClick, column, currentSort, children }: TableSorterProps) {
  const sort = column === currentSort?.column ? currentSort.order : undefined;
  const lightIcon = (
    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.50175 5.00005H0.496927C0.222482 5.00005 0 5.14063 0 5.31405C0 5.37605 0.0290394 5.43665 0.0834587 5.48823L2.58587 7.86014C2.73811 8.00443 3.04663 8.04343 3.27498 7.94723C3.32957 7.92423 3.37641 7.89463 3.41281 7.86014L5.91522 5.48823C6.06745 5.34394 6.00575 5.14898 5.7774 5.05278C5.69577 5.0184 5.59986 5.00005 5.50175 5.00005Z"
        fill="#71757A"
      />
      <path
        d="M0.498248 2.99995H5.50307C5.77752 2.99995 6 2.85937 6 2.68595C6 2.62395 5.97096 2.56335 5.91654 2.51177L3.41413 0.139861C3.26189 -0.00443444 2.95337 -0.0434262 2.72502 0.0527707C2.67043 0.075767 2.62359 0.105366 2.58719 0.139861L0.0847801 2.51177C-0.0674546 2.65606 -0.0057496 2.85102 0.222602 2.94722C0.304231 2.9816 0.400142 2.99995 0.498248 2.99995Z"
        fill="#71757A"
      />
      <path
        d="M5.50175 5H0.496927C0.222482 5 0 5.14059 0 5.31401C0 5.376 0.0290394 5.43661 0.0834587 5.48819L2.58587 7.86009C2.73811 8.00439 3.04663 8.04338 3.27498 7.94718C3.32957 7.92419 3.37641 7.89459 3.41281 7.86009L5.91522 5.48819C6.06745 5.34389 6.00575 5.14893 5.7774 5.05274C5.69577 5.01835 5.59986 5 5.50175 5Z"
        fill="#F7A600"
      />
    </svg>
  );

  return (
    <div className="inline-flex items-center gap-1 cursor-pointer" onClick={onClick}>
      {children}
      <div
        className={clsx({
          'rotate-180': sort === 'asc',
        })}
      >
        {sort === undefined ? (
          <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.50175 5.00005H0.496927C0.222482 5.00005 0 5.14063 0 5.31405C0 5.37605 0.0290394 5.43665 0.0834587 5.48823L2.58587 7.86014C2.73811 8.00443 3.04663 8.04343 3.27498 7.94723C3.32957 7.92423 3.37641 7.89463 3.41281 7.86014L5.91522 5.48823C6.06745 5.34394 6.00575 5.14898 5.7774 5.05278C5.69577 5.0184 5.59986 5.00005 5.50175 5.00005Z"
              fill="#71757A"
            />
            <path
              d="M0.498248 2.99995H5.50307C5.77752 2.99995 6 2.85937 6 2.68595C6 2.62395 5.97096 2.56335 5.91654 2.51177L3.41413 0.139861C3.26189 -0.00443444 2.95337 -0.0434262 2.72502 0.0527707C2.67043 0.075767 2.62359 0.105366 2.58719 0.139861L0.0847801 2.51177C-0.0674546 2.65606 -0.0057496 2.85102 0.222602 2.94722C0.304231 2.9816 0.400142 2.99995 0.498248 2.99995Z"
              fill="#71757A"
            />
          </svg>
        ) : (
          lightIcon
        )}
      </div>
    </div>
  );
}
